import { cn } from '@goaltree/ui/lib/utils'

function Badge({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="badge"
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium transition-colors',
        className,
      )}
      {...props}
    />
  )
}

const CATEGORY_COLORS: Record<string, string> = {
  health: '#FF6452',
  career: '#3DA9FC',
  mind: '#a8ff3e',
  finance: '#FFB020',
  relationships: '#FF5C8A',
  creative: '#A66BFF',
}

function CategoryBadge({
  category,
  label,
  className,
}: {
  category: string
  label?: string
  className?: string
}) {
  const color = CATEGORY_COLORS[category.toLowerCase()] ?? '#6b7280'
  return (
    <span data-slot="category-badge" className={cn('inline-flex items-center', className)}>
      <span className="text-xs font-medium uppercase tracking-wide" style={{ color }}>
        {label ?? category}
      </span>
    </span>
  )
}

export { Badge, CategoryBadge }
